import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@material-ui/core';
import { useForm, FormProvider } from 'react-hook-form';
import { useMutation, useQueryClient } from 'react-query';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import Form from './Form';
import { addAlert } from '../../../actions/alerts.action';
import { updateComment } from '../../../api/managerialDecision/managerialDecisionComment.api';

const Update  = ({ comment, setIsEditing, managerialDecisionId }) => {
  const { t } = useTranslation();
  const form = useForm();
  const dispatch = useDispatch();
  const { employeeId } = useParams();
  const queryClient = useQueryClient();
  const [ error, setError ] = useState('');

  useEffect(() => {
    if (comment) {
      form.reset({
        content: comment.content
      });
    }
  }, [ form, comment ]);

  const updateCommentMutation = useMutation(
    async ({ content }) => {
      await updateComment({ employeeId, managerialDecisionId, commentId: comment?.id, content });
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries([ 'managerialDecisionComments', managerialDecisionId ]);
        setIsEditing(false);
        setError('');
      },
      onError: error => {
        dispatch(addAlert({ message: error.message, severity: 'error' }));
      }
    }
  );

  return (
    <FormProvider { ...form }>
      <form onSubmit={
        form.handleSubmit(values => updateCommentMutation.mutate(values))
      }>
        <Form error={ error } variant={ 'standard' }/>
        <div>
          <Button onClick={ () => setIsEditing(false) } color='inherit' size='small' >
            {t('managerialDecisionComments.form.btn.cancel')}
          </Button>
          <Button
            color='inherit'
            type='sumbit'
            size='small'
            variant='outlined'
            style={ { marginLeft: '10px' } }
          >
            {t('managerialDecisionComments.form.btn.update')}
          </Button>
        </div>
      </form>
    </FormProvider>
  );
};

export default Update;